var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26133 8.40625L4.37662 8.58537C5.99327 10.9377 8.79726 12.5049 12.0001 12.5049C15.2021 12.5049 18.0055 10.9384 19.6223 8.58703L19.7338 8.41102L21.0012 9.21329L20.8823 9.4011C20.8774 9.4088 20.8724 9.41642 20.8673 9.42394C18.9719 12.1896 15.7018 14.0049 12.0001 14.0049C8.29857 14.0049 5.02872 12.1899 3.13333 9.42465C3.12923 9.41867 3.12522 9.41263 3.1213 9.40653L3 9.21807L4.26133 8.40625ZM11.2502 15.9997L11.2502 18.9997H12.7502V15.9997H11.2502ZM5.51313 14.5044L4.01313 17.0044L5.29937 17.7762L6.79937 15.2762L5.51313 14.5044ZM19.9871 17.0044L18.4871 14.5044L17.2009 15.2762L18.7009 17.7762L19.9871 17.0044Z",
    fill: "#66727F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvisible);
export default __webpack_public_path__ + "static/media/invisible.e2bb5e14af04a4fe4e0717d932e81ae6.svg";
export { ForwardRef as ReactComponent };